import BaseNotificationHandler from "./baseHandler.js";

/**
 * Handler for channel-related notifications
 */
class ChannelNotificationHandler extends BaseNotificationHandler {
  /**
   * Build the route to a channel detail page
   * @param {?number} channelId
   * @returns {?string}
   */
  getChannelRoute(channelId) {
    if (!channelId) return null;
    return `/social/channels/${channelId}`;
  }

  getIcon(notification, parsedData) {
    const type = notification.type;
    return (
      {
        channel_invitation_sent: "📨",
        channel_invitation_accepted: "✅",
        channel_join_request_submitted: "📩",
        channel_join_request_approved: "🎉",
        channel_join_request_rejected: "🚫",
        channel_member_removed: "🧹",
        channel_member_role_updated: "🛡️",
        channel_post_pinned: "📌",
        channel_updated: "🔄",
        channel_ownership_transferred: "🧭",
      }[type] ?? super.getIcon(notification, parsedData)
    );
  }

  getMainText(notification, parsedData) {
    const sender = this.getSenderInfo(notification, parsedData) || "Someone";
    const channelName = parsedData.channel_name || "this channel";
    const role = parsedData.role;

    switch (notification.type) {
      case "channel_invitation_sent":
        return `${sender} invited you to join ${channelName}`;
      case "channel_invitation_accepted":
        return `${sender} accepted the invitation to ${channelName}`;
      case "channel_join_request_submitted":
        return `${sender} requested to join ${channelName}`;
      case "channel_join_request_approved":
        return `Your request to join ${channelName} was approved`;
      case "channel_join_request_rejected":
        return `Your request to join ${channelName} was rejected`;
      case "channel_member_removed":
        return `You were removed from ${channelName}`;
      case "channel_member_role_updated":
        return `${sender} changed your role to ${role || "member"} in ${channelName}`;
      case "channel_post_pinned":
        return `${sender} pinned a post in ${channelName}`;
      case "channel_updated":
        return `${sender} updated ${channelName}`;
      case "channel_ownership_transferred":
        return `${sender} transferred ownership of ${channelName}`;
      default:
        return super.getMainText(notification, parsedData);
    }
  }

  getDetails(notification, parsedData) {
    const details = [];
    if (parsedData.channel_name) {
      details.push(`Community: ${parsedData.channel_name}`);
    }
    if (notification.type === "channel_member_role_updated" && parsedData.role) {
      details.push(`Role: ${parsedData.role}`);
    }
    return details.length ? details : super.getDetails(notification, parsedData);
  }

  getActionUrl(notification, parsedData) {
    return parsedData.channel_id
      ? this.getChannelRoute(parsedData.channel_id)
      : super.getActionUrl(notification, parsedData);
  }

  handleClick(notification, parsedData, navigate, onClose) {
    const channelRoute = this.getChannelRoute(parsedData.channel_id);
    if (channelRoute) {
      // If it's a join request notification, open the manage members modal
      if (notification.type === "channel_join_request_submitted") {
        navigate(channelRoute, {
          state: { openManageJoinRequestsModal: true }
        });
      } else {
        navigate(channelRoute);
      }
      if (onClose) onClose();
      return;
    }

    super.handleClick(notification, parsedData, navigate, onClose);
  }
}

export default ChannelNotificationHandler;

